export class CustomFormControlKeyValue {
    constructor(readonly key: string,
                readonly value: any) { }

    static distinct(keyValues: CustomFormControlKeyValue[]): CustomFormControlKeyValue[] {
      const uniq: CustomFormControlKeyValue[] = [];

      keyValues.forEach(kv => {
        const exists = uniq.find(u => u.key === kv.key && u.value === kv.value);
        if (!exists) uniq.push(kv);
      });

      return uniq;
    }
}

export class CustomFormControlDropDownTextValue {
  text: any;
  value: any;

  constructor(text: any, value?: any) {
    this.text = text;
    this.value = value ?? text;
  }
}
